module.exports = __webpack_public_path__ + "static/img/case1.512780a0.png";